import { render, staticRenderFns } from "./signMain.vue?vue&type=template&id=72a215ba&scoped=true"
import script from "./signMain.vue?vue&type=script&lang=js"
export * from "./signMain.vue?vue&type=script&lang=js"
import style0 from "./signMain.vue?vue&type=style&index=0&id=72a215ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a215ba",
  null
  
)

export default component.exports